export const links = {
  TELEGRAM_LINK: 'https://t.me/ostapoleksyn'
}
